import React, { useState } from 'react';

const HeroSection = () => {
  const [videoError, setVideoError] = useState(false);

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Video Background / Fallback */}
      <div className="absolute inset-0 w-full h-full">
        {!videoError ? (
          <video
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="w-full h-full object-cover"
            onError={() => setVideoError(true)}
          >
            <source src="/videos/VIDEO-2025-10-28-15-04-58.mp4" type="video/mp4" />
          </video>
        ) : (
          // Fallback background when video is not available
          <div className="w-full h-full bg-gradient-to-br from-espresso via-espresso/90 to-burnt-amber/30"></div>
        )}
      </div>

      {/* Text Content */}
      <div className="absolute inset-0 flex items-end justify-end pb-20 pr-8 md:pb-32 md:pr-16 lg:pr-24">
        <div className="text-right max-w-2xl">
        <h1 className="font-playfair text-2xl md:text-3xl lg:text-4xl font-bold text-cream leading-tight mb-2 animate-fade-in">
          Crafting Memorable Dining Experiences,
        </h1>
        <h2 className="font-playfair text-2xl md:text-3xl lg:text-4xl font-semibold text-cream leading-tight animate-fade-in">
          One Brunch at a Time.
        </h2>
        <div className="h-1 w-20 md:w-24 bg-burnt-amber ml-auto mt-4"></div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <svg
          className="w-6 h-6 text-cream"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;

